/**
 * `form` — monday's `FormBoardView` (`specs/M4-V8-forms.md`).
 *
 * The registry entry is deliberately thin: a form's real configuration lives in the `forms` table
 * and is validated by `formSettingsSchema`, not by the view's `settings` blob. What the view row
 * keeps is monday's own JSON, rendered by `formToMondayViewData()` for `settings_str` parity.
 */
import { z } from 'zod';
import { defineViewType } from '../types.js';
export * from './types.js';
export * from './from-monday.js';
export * from './to-monday.js';
export * from './validate.js';
export const formViewSettingsSchema = z.looseObject({});
export const formView = defineViewType({
    id: 'form',
    title: 'Form',
    mondayViewType: 'FormBoardView',
    kind: 'FORM',
    settingsSchema: formViewSettingsSchema,
    defaultSettings: {},
    requiredColumnTypes: [],
    // A form shows questions, not items: monday offers it no filter, sort or group-by.
    supportsFilters: false,
    supportsSort: false,
    supportsGroupBy: false,
    // A board whose default view is a form would open on a form; monday never does that.
    canBeDefault: false,
    implemented: true,
    plannedIn: null,
    gallery: { order: 9, section: 'board-views' },
});
//# sourceMappingURL=index.js.map